export type HqIdRouteParams = "hqId";
export type PropertyIdRouteParams = "propertyId";
export type ProgramInstanceRouteParams = "programInstanceId";

export type HqAndOfficeIdRouteParams = "hqId" | "officeId";

export type OrderAndCampaignTemplateRouteParams =
  | "orderId"
  | "campaignTemplateId";

export const isValidRouteParam = (guid: string) => {
  if (guid.startsWith(":")) return true;

  const regexGuid =
    /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
  return regexGuid.test(guid);
};
